export const TABS_DATA = [
  { id: 'ServiceItemTypeDetail', label: 'Service Item Type Maintenance' },
];
